
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'pause': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM9.16667 13.3333C9.16667 13.7933 8.79333 14.1667 8.33333 14.1667C7.87333 14.1667 7.5 13.7933 7.5 13.3333V6.66667C7.5 6.20667 7.87333 5.83333 8.33333 5.83333C8.79333 5.83333 9.16667 6.20667 9.16667 6.66667V13.3333ZM11.6667 14.1667C12.1267 14.1667 12.5 13.7933 12.5 13.3333V6.66667C12.5 6.20667 12.1267 5.83333 11.6667 5.83333C11.2067 5.83333 10.8333 6.20667 10.8333 6.66667V13.3333C10.8333 13.7933 11.2067 14.1667 11.6667 14.1667Z" fill="#93A0AE"/>'
  }
})
